import { Typography } from "antd";
import { TabsAndTaskHistory } from "components/Shared/TabsAndTaskHistory";
import { useIntl } from "react-intl";
import { FixtureRosterTab } from "./components/FixtureRosterTab";
import { FixtureStaffTab } from "./components/FixtureStaffTab";
import { UniformTab } from "./components/UniformTab";

type Props = {
  viewOnly: boolean;
  isLoading: boolean;
  fixture: any;
  roster: Array<any>;
  staff: Array<any>;
  entityId: string;
};

export const FixtureView = ({ viewOnly, isLoading, fixture, roster, staff, entityId }: Props) => {
  const { formatMessage } = useIntl();

  const tabs = [
    {
      key: "roster",
      label: <Typography.Text className="text-upper">{formatMessage({ id: "rosterTab.title" })}</Typography.Text>,
      children: <FixtureRosterTab isLoading={isLoading} fixture={fixture} viewOnly={viewOnly} roster={roster} />,
    },
    {
      key: "staff",
      label: <Typography.Text className="text-upper">{formatMessage({ id: "staffTab.title" })}</Typography.Text>,
      children: <FixtureStaffTab isLoading={isLoading} fixture={fixture} viewOnly={viewOnly} staff={staff} />,
    },
    {
      key: "uniform",
      label: <Typography.Text className="text-upper">{formatMessage({ id: "uniformTab.title" })}</Typography.Text>,
      children: <UniformTab fixture={fixture} entityId={entityId} viewOnly={viewOnly} />,
    },
  ];

  return (
    <TabsAndTaskHistory
      isLoading={isLoading}
      entityId={entityId}
      fixture={fixture}
      roster={roster}
      staff={staff}
      tabs={tabs}
    />
  );
};
